/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
window.ismobile =
  navigator.userAgent.match(/Android/i) ||
  navigator.userAgent.match(/webOS/i) ||
  navigator.userAgent.match(/iPhone/i) ||
  navigator.userAgent.match(/iPod/i) ||
  navigator.userAgent.match(/BlackBerry/i) ||
  navigator.userAgent.match(/Windows Phone/i)

window.Vue = require('vue')
require('./bootstrap')

window.bairro = 0

require('./plugins/select2')
require('./plugins/owl-carousel')
require('./plugins/stick-menu')
require('./plugins/masked-input')
// require('./plugins/jquery.transit');
require('./plugins/jquery.payment')
require('./plugins/jquery.blockUI')
// require('./plugins/tether');
// Shepherd = require('./plugins/shepherd.min');

require('./components/efeitos')
require('./components/select2')
require('./components/carousel')
require('./components/imovel')
require('./components/form-home')
require('./components/form-experiencia')
require('./components/filtros-imovel')
require('./components/btn-favoritar')
require('./components/form-contato')
require('./components/form-anunciante')
require('./components/area-minha-conta')
require('./components/area-outros-formularios')
require('./components/anunciar')
require('./components/novo-anunciar')
require('./components/anuncie')
require('./components/cadastro-usuario')
require('./components/form-contato-fale-anunciante')
require('./components/login')

jQuery(document).ready(function($) {
  // setInterval(function() {
  // 	$('#general-style').attr('href','css/style.css?v='+(new Date()).getTime());
  // },2000);
  $(window).scroll(function(event) {
    var width = $(window).width() <= 780 ? 200 : 260

    if ($(window).scrollTop() > width) $('body').addClass('scroll-mobile')
    else $('body').removeClass('scroll-mobile')
  })

  $(document).on('change', '.refresh-onchange', function(event) {
    window.location.href = this.value
  })

  $('.overlayall').hide()

  $('input[data-mask]').each(function(index, el) {
    $(el).mask(el.getAttribute('data-mask'), { reverse: el.getAttribute('data-reverse') == '1' })
  })

  var SPMaskBehavior = function(val) {
      return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009'
    },
    spOptions = {
      onKeyPress: function(val, e, field, options) {
        field.mask(SPMaskBehavior.apply({}, arguments), options)
      }
    }

  $('input[data-maskphone]').each(function(index, el) {
    $(el).mask(SPMaskBehavior, spOptions)
  })
  // $('input[data-masked]').each(function(index, el) {
  //     $(el).mask(el.getAttribute('data-masked'), { reverse: (el.getAttribute('data-reverse') == "1") });
  // });

  // $('.maskmoney').mask('000.000.000.000.000', {reverse: true});

  if ($(window).width() >= 1200) {
    $('.sticky-sidebar').stick_in_parent()
    $('.lista-imoveis-filtros .publicidade').stick_in_parent()
  }

  $(document)
    .on('focus', '.contato-form-campo input, .contato-form-campo textarea', function(event) {
      $(this)
        .parents('.contato-form-campo')
        .addClass('active')
    })
    .on('blur', '.contato-form-campo input, .contato-form-campo textarea', function(event) {
      if ($(this).val() == '')
        $(this)
          .parents('.contato-form-campo')
          .removeClass('active')
    })

  $(document).on('click', '.modal-geral-fechar, .modal-fechar, .btn-fechar-modal', function(event) {
    $(this)
      .closest('.modal-geral, .modal-primary, #modal')
      .hide()

    if (window.ultimoBotaoEntrarContatoAberto != undefined) {
      $(window.ultimoBotaoEntrarContatoAberto).html('Entrar em contato')
    }

    return false
  })

  $(document).on('change', '.form-group-radio input', function(event) {
    $(this)
      .parents('.form-group-radio')
      .find('label')
      .removeClass('active')
    $(this)
      .closest('label')
      .addClass('active')
  })

  $(document).on('change', '.btn-filter input', function(event) {
    if ($(this).is(':checked'))
      $(this)
        .closest('.btn-filter')
        .addClass('btn-filter-selected')
    else
      $(this)
        .closest('.btn-filter')
        .removeClass('btn-filter-selected')
  })

  $('.btn-load-modal').on('click', function(event) {
    event.preventDefault()

    var html = $(this).html()

    $(this).html('<i class="fa fa-spin fa-spinner"></i> Aguarde...')

    $.ajax({
      url: this.getAttribute('data-url')
    }).done(function(data) {
      if (data == null || data == '') {
      } else {
        $('#modal .modal-data').html(data)
        $('#modal').show()

        $('#modal .modal-data input[data-mask]').each(function(index, el) {
          $(el).mask(el.getAttribute('data-mask'), { reverse: el.getAttribute('data-reverse') == '1' })
        })
        $('#modal .modal-data input[data-maskphone]').each(function(index, el) {
          $(el).mask(SPMaskBehavior, spOptions)
        })
      }

      $(event.currentTarget).html(html)
    })

    return false
  })

  window.loadDivContent = function(that) {
    var url = $(that).attr('data-href')
    if (
      $(that)
        .attr('data-href')
        .indexOf('?') >= 0
    )
      url = url + '&width=' + $(window).width()
    else url = url + '?width=' + $(window).width()

    $(that).load(url, function() {
      $(that).removeClass('load-content')

      $(that)
        .find('.owl-carousel')
        .owlCarousel({
          lazyLoad: true,
          loop: true,
          dots: false,
          nav: true,
          navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
        })

      $(that)
        .find('.grid-imovel-list.owl-carousel2')
        .owlCarousel({
          responsive: {
            0: {
              items: 1
            },
            780: {
              items: 2
            },
            1090: {
              items: 3
            }
          },
          lazyLoad: true,
          loop: true,
          dots: false,
          nav: true,
          navText: ['<i class="fa fa-angle-left"></i>', '<i class="fa fa-angle-right"></i>']
        })
      $(that)
        .find('.select2')
        .select2()
    })
  }

  $('.load-content').each(function(index, el) {
    loadDivContent(this)
  })

  $('.server-messages').each(function(index, el) {
    if ($(el).attr('data-type') == 'success') {
      swal({
        title: 'Sucesso!',
        html: $(el).val(),
        type: 'success'
      })
    } else if ($(el).attr('data-type') == 'error') {
      swal({
        title: 'Algo deu errado!',
        html: $(el).val(),
        type: 'error'
      })
    }
  })

  $('.btn-action').click(function(event) {
    if ($(this).hasClass('btn-activated')) return

    $(this).addClass('btn-activated')
    setTimeout(function() {
      $(event.currentTarget).removeClass('btn-activated')
    }, 2000)
  })

  $('.btn-menu-mobile').click(function(event) {
    $('#menu-mobile').show()
    $('#menu-mobile #menu-mobile-content').animate({ marginLeft: 0 }, 400)
  })

  $('#menu-mobile .overlay, #menu-mobile #menu-mobile-content i.fa.fa-remove').click(function(event) {
    $('#menu-mobile').hide()
    $('#menu-mobile #menu-mobile-content').css({ marginLeft: '-270px' })
  })

  if ($('input.server-scroll')[0] && $($('input.server-scroll').val())[0]) {
    $('body,html').animate({ scrollTop: $($('input.server-scroll').val()).offset().top - 50 }, 300)
  }

  $('.newsletter-form').submit(function(event) {
    event.preventDefault()

    if (
      $(this)
        .find('input[name=email]')
        .val() == ''
    ) {
      swal({
        title: 'Algo deu errado!',
        text: 'Você deve preencher seu e-mail para se cadastrar!',
        type: 'error'
      })
      return false
    }

    var btn = $(this).find('.btn')
    var html = btn.html()

    btn.stop().animate({ minWidth: '100%' }, 300)
    btn.html('<i class="fa fa-spin fa-spinner"></i> Aguarde...')

    $.ajax({
      url: $(this).attr('action'),
      type: 'POST',
      data: $(this).serialize()
    }).done(function() {
      //  swal({
      //     title: "Sucesso!",
      //     text: 'E-mail cadastrado com sucesso.',
      //     type: "success"
      // });

      btn.html('Sucesso!').addClass('btn-green')

      setTimeout(function() {
        btn
          .html(html)
          .stop()
          .animate({ minWidth: '0%' }, 300)
          .removeClass('btn-green')
      }, 1500)
    })

    return false
  })

  if ($('.modal-anunciante-logado')[0]) {
    $('.modal-anunciante-logado .modal-acao-fechar').click(function(event) {
      $('.modal-anunciante-logado').hide()
      return false
    })
  }

  $('li.mostrar-aviso > a').on('click', () => {
    window.sendAdoptCommand('open')
    return false
  })

  window.waitForGlobal('window.sendAdoptCommand', () => {
    $('li.mostrar-aviso').show()
  })

  $(window).on('resize', () => {
    if (!$('.btn-menu-mobile').is(':visible')) {
      $('#menu-mobile').hide()
      $('#menu-mobile #menu-mobile-content').css({ marginLeft: '-270px' })
    }
  })
})

window.validateCPF = function(strCPF) {
  strCPF = strCPF.replace(/[^\d]+/g, '')

  var Soma
  var Resto
  Soma = 0
  if (strCPF == '00000000000') return false

  for (i = 1; i <= 9; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (11 - i)
  Resto = (Soma * 10) % 11

  if (Resto == 10 || Resto == 11) Resto = 0
  if (Resto != parseInt(strCPF.substring(9, 10))) return false

  Soma = 0
  for (i = 1; i <= 10; i++) Soma = Soma + parseInt(strCPF.substring(i - 1, i)) * (12 - i)
  Resto = (Soma * 10) % 11

  if (Resto == 10 || Resto == 11) Resto = 0
  if (Resto != parseInt(strCPF.substring(10, 11))) return false
  return true
}

window.validateCNPJ = function(cnpj) {
  cnpj = cnpj.replace(/[^\d]+/g, '')
  if (cnpj == '') return false

  if (cnpj.length != 14) return false

  // Elimina CNPJs invalidos conhecidos
  if (
    cnpj == '00000000000000' ||
    cnpj == '11111111111111' ||
    cnpj == '22222222222222' ||
    cnpj == '33333333333333' ||
    cnpj == '44444444444444' ||
    cnpj == '55555555555555' ||
    cnpj == '66666666666666' ||
    cnpj == '77777777777777' ||
    cnpj == '88888888888888' ||
    cnpj == '99999999999999'
  )
    return false

  // Valida DVs
  tamanho = cnpj.length - 2
  numeros = cnpj.substring(0, tamanho)
  digitos = cnpj.substring(tamanho)
  soma = 0
  pos = tamanho - 7
  for (i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) pos = 9
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  if (resultado != digitos.charAt(0)) return false

  tamanho = tamanho + 1
  numeros = cnpj.substring(0, tamanho)
  soma = 0
  pos = tamanho - 7
  for (i = tamanho; i >= 1; i--) {
    soma += numeros.charAt(tamanho - i) * pos--
    if (pos < 2) pos = 9
  }
  resultado = soma % 11 < 2 ? 0 : 11 - (soma % 11)
  if (resultado != digitos.charAt(1)) return false

  return true
}

window.btnLoadModalClick = function(object, event) {
  // console.log('isSeePhoneFormWithClass: ', $(object).hasClass('see-phone-submit'));
  event.preventDefault()

  // console.log($(object).html());
  var html = $(object).html()

  // window.isListagemModalEntrarContatoAberto = false;

  if ($(object).hasClass('btn-entrar-contato')) {
    window.isListagemModalEntrarContatoAberto = true;
  }

  $(object).html('<i class="fa fa-spin fa-spinner"></i> Aguarde...')

  $.ajax({
    url: object.getAttribute('data-url')
  }).done(function(data) {
    if (data == null || data == '') {
    } else {
      $('#modal .modal-data').html(data)
      $('#modal').show()

      $('#modal .modal-data input[data-mask]').each(function(index, el) {
        $(el).mask(el.getAttribute('data-mask'), { reverse: el.getAttribute('data-reverse') == '1' })
      })

      var SPMaskBehavior = function(val) {
          return val.replace(/\D/g, '').length === 11 ? '(00) 00000-0000' : '(00) 0000-00009'
        },
        spOptions = {
          onKeyPress: function(val, e, field, options) {
            field.mask(SPMaskBehavior.apply({}, arguments), options)
          }
        }

      $('#modal .modal-data input[data-maskphone]').each(function(index, el) {
        $(el).mask(SPMaskBehavior, spOptions)
      })

      window.ultimoBotaoEntrarContatoAberto = object
    }

    $(event.currentTarget).html(html)
  })

  return false
}

window.initGoogle = function() {
  gapi.load('auth2', function() {
    var auth2 = gapi.auth2.init({
      client_id: '247910312944-kgfgv03cb23bfoqjpj8i9v1uqvpt5ljr.apps.googleusercontent.com',
      fetch_basic_profile: true,
      scope: 'profile'
    })
  })
}

window.logout = function() {
  facebookLogout()
  googleLogout()
  window.location = '/logout'
}

function facebookLogout() {
  if (typeof FB !== 'undefined') {
    FB.getLoginStatus(function(response) {
      if (response.status === 'connected') {
        FB.logout(function(response) {})
      }
    })
  }
}

function googleLogout() {
  let auth2 = gapi.auth2.getAuthInstance()
  auth2.signOut().then(function() {})
}

window.getProductsIds = () => {
  let products = document.querySelectorAll('#prodid')
  products = Array.prototype.slice.call(products)
  return products.map(e => e.value)
}

window.getTotalValue = () => {
  let prices = document.querySelectorAll('#totalvalue')
  prices = Array.prototype.slice.call(prices)
  return prices.reduce((total, value) => {
    let numberValue = parseFloat(value.value)
    if (numberValue) {
      total += numberValue
    }
    return total
  }, 0)
}

window.getCategory = () => {
  let categories = document.querySelectorAll('#category')
  categories = Array.prototype.slice.call(categories)
  categories = categories.map(e => e.value)
  return categories.length ? categories[0] : ''
}

window.checkNested = function(obj, args) {
  for (var i = 0; i < args.length; i++) {
    if (!obj || !obj.hasOwnProperty(args[i])) {
      return false
    }
    obj = obj[args[i]]
  }
  return true
}

window.waitForGlobal = function(keyPath, callback) {
  var args = keyPath.split('.')
  if (window.checkNested(window, args)) {
    callback()
  } else {
    setTimeout(function() {
      window.waitForGlobal(keyPath, callback)
    }, 100)
  }
}
